<template>
    <v-container fluid style="padding: 24px 14px;">
        <v-layout row justify-center>
            <v-flex lg12 md12>
                <v-card dark>
                    <v-card-title>
                        Event Control
                    <v-spacer />
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details />
                    </v-card-title>
                    <v-flex left ml-3 row>
                        <div class="status-normal">Normal</div>
                        <div class="status-error">User setting : Not run on server</div>
                        <div class="status-warning">User don't setting : Run on server</div>
                    </v-flex>
                    <v-flex right mr-4>
                        <v-btn
                            color="green darken-1"
                            style="text-transform: none !important; outline: none;"
                            dark
                            round
                            small
                            @click="getDatatable"
                        >
                            <v-icon size="22">refresh</v-icon>
                            <span>Reload Table &nbsp;</span>
                        </v-btn>
                        <v-btn
                            color="red darken-1"
                            style="text-transform: none !important; outline: none;"
                            dark
                            round
                            small
                            @click="restartAll"
                        >
                            <v-icon size="22">autorenew</v-icon>
                            <span>Restart Cronjobs &nbsp;</span>
                        </v-btn>
                    </v-flex>
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="datatables"
                        :search="search"
                        :loading="loadTable"
                        :pagination.sync="pagination"
                        item-key="eventid"
                        >
                    <v-progress-linear slot:progress color="blue" indeterminate></v-progress-linear>
                    <template slot="items" slot-scope="props">
                        <tr>
                            <td>
                                <v-checkbox
                                v-model="props.selected"
                                primary
                                hide-details
                                disabled
                                />
                            </td>
                            <td class="text-xs-left">{{ props.item.instance }}</td>
                            <td class="text-xs-left">{{ props.item.username.toString().substring(0, 40) }}</td>
                            <td class="text-xs-left">{{ props.item.title }}</td>
                            <td class="text-xs-left"
                                :style="
                                    props.item.status === 'Working' ?
                                        'color: #4CAF50;': props.item.status === 'Not work' ?
                                        'color: #EF5350;': 'color: #FFEB3B;'
                                    "
                                >
                                {{ props.item.status }}
                            </td>
                            <td class="text-xs-left">{{ props.item.eventid }}</td>
                            <td class="text-xs-left">{{ props.item.time }}</td>
                            <td class="text-xs-center">
                                <v-tooltip bottom>
                                    <v-btn
                                        slot="activator"
                                        flat
                                        icon
                                        style="outline: none;"
                                        @click="restartEvent(props.item)" >
                                        <v-icon size="24" color="#FFFF00">autorenew</v-icon>
                                    </v-btn>
                                    <span>Restart Event</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <v-btn
                                        slot="activator"
                                        flat
                                        icon
                                        style="outline: none;"
                                        @click="droptEvent(props.item)"  >
                                        <v-icon size="22" color="#FF1744">remove_circle_outline</v-icon>
                                    </v-btn>
                                    <span>Drop Event</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:no-results>
                        <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                        </v-alert>
                    </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-snackbar
            v-model="snackbar"
            :bottom="false"
            :left="false"
            :multi-line="true"
            :right="false"
            :timeout="5000"
            :top="true"
            :vertical="false">
        {{ snackbartext }}
            <v-btn
                color="pink"
                flat
                style="outline: none;"
                @click="snackbar = false">
            Close
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
import axios from 'axios'
export default {
    name: 'notification',
    data () {
         return {
            snackbar: false,
            snackbartext: '',
            selected: [],
            search: '',
            headers: [
                {
                    text: '',
                    value: '',
                    align: 'left',
                    sortable: false
                },
                {
                    text: 'Instance',
                    value: 'instance',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Username',
                    value: 'username',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Title',
                    value: 'title',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Status',
                    value: 'status',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'EventID',
                    value: 'eventid',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Time',
                    value: 'time',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Action',
                    value: 'action',
                    align: 'center',
                    sortable: true
                }
            ],
            datatables: [],
            loadTable: false,
            pagination: {
                descending: true,
                rowsPerPage: 25,
                sortBy: 'username'
            }
         }
    },
    created () {
        this.getDatatable()
        // setInterval(() => {
        //     this.getDatatable()
        // }, 10000)
    },
    methods: {
        async getDatatable () {
            this.loadTable = true
            this.datatables = []
            // console.log('Event Control')
            let response = await axios.post(apiUrl + '/api/status/eventCL', {
                command: 'get'
            })
            response.data.pdpa.map(el => {
                if (el != null) {
                    this.datatables.push(el)
                }
            })
            response.data.alert.map(el => {
                 if (el != null) {
                    this.datatables.push(el)
                 }
            })
            this.loadTable = false
        },
        async restartEvent (e) {
            // console.log(e)
            let response
            if (e.type === 'pdpa') {
                response = await axios.post(apiUrl + '/api/status/eventCL', {
                    eventid: e.eventid,
                    time: e.time,
                    command: 'restartpdpa'
                })
            } else if (e.type === 'alert') {
                response = await axios.post(apiUrl + '/api/status/eventCL', {
                    eventid: e.eventid,
                    time: e.time,
                    command: 'restartalert'
                })
            }
            if (response.data.msg === 'ok') {
                this.snackbartext = `Restert Event ${e.eventid} Sucessfully`
                this.snackbar = true
                setTimeout(() => {
                    this.getDatatable()
                }, 1000)
            }
        },
        async restartAll () {
            let response = await axios.post(apiUrl + '/api/status/eventCL', {
                command: 'restartall'
            })
            if (response.data.msg === 'ok') {
                this.snackbartext = 'Restert All Event Sucessfully'
                this.snackbar = true
                setTimeout(() => {
                    this.getDatatable()
                }, 500)
            }
        },
        async droptEvent (e) {
            // console.log(e)
            let response
            if (e.type === 'pdpa') {
                response = await axios.post(apiUrl + '/api/status/eventCL', {
                    eventid: e.eventid,
                    command: 'droppdpa'
                })
            } else if (e.type === 'alert') {
                response = await axios.post(apiUrl + '/api/status/eventCL', {
                    eventid: e.eventid,
                    command: 'dropalert'
                })
            }
            if (response.data.msg === 'ok') {
                this.snackbartext = `Drop Event ${e.eventid} Sucessfully`
                this.snackbar = true
                setTimeout(() => {
                    this.getDatatable()
                }, 1000)
            }
        }
    }
}
</script>

<style scoped>
.status-normal {
    background-color: #4CAF50;
    width: 80px;
    height: 24px;
    border-radius: 16px;
    margin: 0 5px;
}
.status-warning {
    background-color: #FFEB3B;
    width: 230px;
    height: 24px;
    color: #000;
    border-radius: 16px;
    margin: 0 5px;
}
.status-error {
    background-color: #EF5350;
    width: 220px;
    height: 24px;
    border-radius: 16px;
    margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/eventControl.vue